import { useEffect, useState } from 'react';
import { isAssistantAvailable } from './plugin';
import { closeAssistant, openAssistant, toggleAssistant, type OpenAssistantProps } from './sidebar';

export type AssistantHook = {
  /** Whether the availability check is still in progress. */
  isLoading: boolean;
  isAvailable: boolean;
  openAssistant: ((props: OpenAssistantProps) => void) | undefined;
  closeAssistant: (() => void) | undefined;
  toggleAssistant: ((props: OpenAssistantProps) => void) | undefined;
};
/**
 * Hook to check if the assistant is available and return the open, close, and toggle functions.
 * @returns {AssistantHook}
 */
export function useAssistant(): AssistantHook {
  const [available, setAvailable] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const sub = isAssistantAvailable().subscribe(setAvailable);
    return () => sub.unsubscribe();
  }, []);

  const isAvailable = available ?? false;

  return {
    isLoading: available === undefined,
    isAvailable,
    openAssistant: isAvailable ? openAssistant : undefined,
    closeAssistant: isAvailable ? closeAssistant : undefined,
    toggleAssistant: isAvailable ? toggleAssistant : undefined,
  };
}
